import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/** Allows only users with GET /admin/me/permissions → isSuperAdmin: true. */
export default function SuperAdminRoute({ children }) {
  const perm = useSelector((s) => s.permissions);

  if (perm.fruitMode) {
    return <Navigate to="/forbidden" replace />;
  }
  if (!perm.loaded) {
    return null;
  }
  if (!perm.isSuperAdmin) {
    return <Navigate to="/forbidden" replace />;
  }
  return children;
}
